import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { Colors } from 'copyright-clearance-center-common-ui';

const BorderlessTextField = styled(TextField)({
	'& .MuiOutlinedInput-root': {
		'& fieldset': {
			border: 'none'
		},
		'&:hover fieldset': {
			border: 'none'
		},
		'&.Mui-focused fieldset': {
			border: 'none'
		},
		padding: 0
	},
	'& .MuiOutlinedInput-input::placeholder': {
		fontSize: '0.875rem',
		color: Colors.neutral600
	},
	flexBasis: '100%'
});

export default BorderlessTextField;
